import React, { useEffect, useState } from "react";
import { Grid, Section, BreadCrumbBox, FilterWraper, Loading } from "../../core";
import SizerPaymentHistory from "../../components/SizerPaymentHistoryTabel";
import {
  getSizerBills,
  mapSizerBillsForPaymentHistory,
} from "../../helper/utils/api/sizer";
import { getCompanyId } from "../../helper/utils/companyId";

const PaymentHistory = () => {
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const load = async () => {
      const companyId = getCompanyId();
      if (!companyId) return;
      setIsLoading(true);
      try {
        const { data } = await getSizerBills(companyId);
        const list = Array.isArray(data) ? data : data?.result || [];
        setRows(mapSizerBillsForPaymentHistory(list));
      } catch (error) {
        console.log("sizer payment history error", error);
        setRows([]);
      }
      setIsLoading(false);
    };
    load();
  }, []);

  return (
    <Grid>
      <BreadCrumbBox tittle="Payment History" />
      <Section padding="20px">
        {isLoading ? <Loading /> : null}
        <FilterWraper>
          <SizerPaymentHistory PaymentHistoryData={rows} />
        </FilterWraper>
      </Section>
    </Grid>
  );
};

export default PaymentHistory;
